export default __webpack_public_path__ + "media/color/nebl-74d67396.svg";